import { subCompanyAgencyApprovalsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUB_COMPANY_AGENCY_APPROVALS_ACTION_TYPE = createNamedActions(
  'subCompanyAgencyApprovals',
  {
    GET_AGENCY_APPROVALS: 'GET_AGENCY_APPROVALS',
    UPSERT_AGENCY_APPROVALS: 'UPSERT_AGENCY_APPROVALS',
    RESET_STATE: 'RESET_STATE',
  },
);

export const getSubCompanyAgencyApprovalsAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await subCompanyAgencyApprovalsApi.getSubCompanyAgencyApprovals(params);

    return dispatch({
      type: SUB_COMPANY_AGENCY_APPROVALS_ACTION_TYPE.GET_AGENCY_APPROVALS,
      payload: data,
    });
  },
);

export const upsertSubCompanyAgencyApprovalsAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await subCompanyAgencyApprovalsApi.upsertSubCompanyAgencyApprovals(params);

    return dispatch({
      type: SUB_COMPANY_AGENCY_APPROVALS_ACTION_TYPE.UPSERT_AGENCY_APPROVALS,
      payload: data,
    });
  },
);
